// import { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { enqueueSnackbar } from 'notistack';

// export default function SessionManager() {
//   const navigate = useNavigate();

// useEffect(() => {
//   const handleSessionExpired = () => {
//     sessionStorage.clear();
// const user_id = localStorage.getItem('id')
// // console.log("user_id-----------",user_id)
// if(user_id){
//  enqueueSnackbar('Your account was logged in elsewhere.', {
//       variant: 'warning',
//       autoHideDuration: 4000
//     });
//     localStorage.removeItem('id')
// }
//     navigate('/auth/jwt/login?returnTo=%2Fdashboard', { replace: true });
//   };

//   window.addEventListener('sessionExpired', handleSessionExpired);

//   return () => {
//     window.removeEventListener('sessionExpired', handleSessionExpired);
//   };
// }, [navigate]);


//   return null; // 👈 doesn't render anything
// }





import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import { useAuthContext } from 'src/auth/hooks';

export default function SessionManager() {
  const navigate = useNavigate();
  const { logout, authenticated } = useAuthContext();

  useEffect(() => {
    const handleSessionExpired = () => {
      // ⛔ prevent duplicate execution
      // if (!authenticated) return;
 sessionStorage.clear();
      // 🔐 Reset auth state FIRST

const user_id = localStorage.getItem('id')
// if(user_id){
 enqueueSnackbar('Your account was logged in elsewhere.', {
      variant: 'warning',
      autoHideDuration: 4000
    });
    localStorage.removeItem('id')
// }
           logout();

      // 🚀 Immediate redirect
      navigate('/auth/jwt/login', { replace: true });
    };

    window.addEventListener('sessionExpired', handleSessionExpired);

    return () => {
      window.removeEventListener('sessionExpired', handleSessionExpired);
    };
  }, [logout, navigate]);

  return null;
}
